import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import { Grid } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import type { DegreePageContentFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import Container from 'bundles/xddp/components/shared/Container';
import InfoSidebar from 'bundles/xddp/components/shared/InfoSidebar';
import type { UserAgentProps } from 'bundles/xddp/types';

type Props = UserAgentProps & {
  pageContent: DegreePageContentFragment;
  specializationSlug: string;
};

class SpecializationPage extends React.Component<Props> {
  render() {
    const { pageContent, specializationSlug, userAgent } = this.props;
    const { specializationsCollection, atAGlance } = pageContent;

    const matchedSpecialization = specializationsCollection?.items?.find(
      (specialization) => specialization !== null && specialization.slug === specializationSlug
    );

    if (!matchedSpecialization) {
      return null;
    }

    const { specializationOverview } = matchedSpecialization;

    return (
      <div className="rc-SpecializationPage">
        <Container>
          <Grid container>
            <Grid item md={8}>
              <Markdown className="specializationOverview rc-Section" source={specializationOverview} />
            </Grid>
            <InfoSidebar userAgent={userAgent} atAGlance={atAGlance} />
          </Grid>
        </Container>
      </div>
    );
  }
}

export default compose<Props, Props>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'xddp',
      page: 'about_page',
    },
  }))
)(SpecializationPage);
